import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  alert: {
    marginTop: "30px",
  },
});

export default useStyles;
